module.exports = __webpack_public_path__ + "img/maxim-hopman-8cT5ja0P_N4-unsplash.c91711d7.jpg";